export const environment = {
  url: '',
  baseUrl: '',
  hostname: '',
  calendarBaseUrl: '',
  contentful: {
    space: '',
    accessToken: '',
    landindPageId: '',
    environment: '',
  },
  cookieDomainScript: '',
};
